export function parsePath(path: string): [string, number] {
  const normalized = path.replace(/\[(\d+)\]/, '.$1');

  const parts = normalized.split('.');
  const index = parseInt(parts[parts.length - 1], 10);

  const sectionPath = parts.slice(0, -2).join('.');

  return [sectionPath, index];
}